import { render, staticRenderFns } from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=template&id=c07ffd6a&scoped=true&lang=html"
import script from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=style&index=0&id=c07ffd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07ffd6a",
  null
  
)

export default component.exports